<div class="dropdown">
  <button
    class="dropdown-toggle resource-dropdown-button p-0"
    type="button"
    [id]="dropdownData?.dropdownMenuID"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    >
    <div class="d-flex flex-row align-items-center justify-content-between">
      <span id="current-selection">{{ initialDropdownTitle }}</span>
      <div class="d-flex flex-row align-items-center py-base icon-border">
        <mat-icon id="gated-content-header-icon" class="mx-base" svgIcon="chevron_down"></mat-icon>
      </div>
    </div>
  </button>
  <ul class="dropdown-menu" [attr.aria-labelledby]="dropdownData?.dropdownMenuID">
    @for (item of dropdownData.listItems; track item; let i = $index) {
      <div
        class="dropdown-item-container"
        role="link"
        [routerLink]="item.href"
        (keydown.enter)="navigate(item.href)"
        >
        <li class="dropdown-list">
          <a class="px-3">{{ item.title }}</a>
        </li>
      </div>
    }
    <div id="return-home-container">
      @if (returnToHomepageLink === true) {
        <li class="mx-3 dropdown-list return-home">
          <div>
            <a class="dropdown-item" routerLink="/">Return to Homepage</a>
          </div>
        </li>
      }
    </div>
  </ul>
</div>
